<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_393_4023"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="1"
      y="4"
      width="19"
      height="15"
    >
      <path d="M1 4H19.466V18.247H1V4Z" fill="white" />
    </mask>
    <g mask="url(#mask0_393_4023)">
      <path
        d="M18.1482 4C17.9632 4.00015 17.7802 4.03922 17.6112 4.11468C17.4422 4.19014 17.2909 4.3003 17.1672 4.438L7.66724 15.013L3.24924 10.61C3.00124 10.3635 2.66557 10.2255 2.31592 10.2263C1.96626 10.227 1.63119 10.3665 1.38424 10.614C1.13746 10.862 0.999253 11.1979 1 11.5478C1.00075 11.8977 1.1404 12.233 1.38824 12.48L6.79424 17.863C6.91642 17.9853 7.06158 18.0821 7.22137 18.148C7.38115 18.2139 7.5524 18.2476 7.72524 18.247H7.76124C8.12224 18.236 8.46424 18.079 8.70624 17.81L19.1302 6.2C19.3 6.01019 19.4113 5.77532 19.4506 5.52372C19.4899 5.27211 19.4555 5.01451 19.3517 4.78196C19.2479 4.54942 19.0791 4.35187 18.8656 4.21312C18.652 4.07438 18.4029 4.00036 18.1482 4Z"
        fill="#FF693B"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "ArrowBlue",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["small", "medium", "large", "xxlarge"].includes(value);
      },
    },
  },
};
</script>

<style scoped>
.st0 {
  fill: #619bc4;
}
.medium {
  height: 24px;
  width: auto;
}
.large {
  height: 60px;
  width: auto;
}
.xxlarge {
  height: 84px;
  width: auto;
}
</style>
